<script>
import {defineAsyncComponent} from 'vue'
import Main from './components/Main.vue'
import Slider from './components/Slider.vue'
import CompleteProject from './components/Projects/CompleteProject.vue'
import Profile from './components/Profile.vue'
import Registration from './components/Registration.vue'
import AreaQuiz from './components/AreaQuiz.vue'
import AreasInfo from "./components/AreasInfo.vue";
import CoordTable from "./components/CoordTable";
import ForumForm from "./components/ForumForm";
import ForumReport from "./components/ForumReport";
import Startup from "./components/Startup";
import FprkProject from "./components/FprkProject.vue";
import News from "./components/News";
import Comissions from "./components/Comissions";
import ExpertProjects from "./components/ExpertProjects";
import NewsList from "@/components/NewsList";
import Criterion from "@/components/Criterion.vue";
import RussiaFutureComponent from "@/components/RussiaFutureComponent.vue";
import EditExpert from "@/components/EditExpert.vue";
import CompetitionEdit from "./components/CompetitionEdit.vue"
import CompetitionLists from "./components/CompetitionLists.vue"
import FilmCompany from "./components/FilmCompany.vue"
import FilmCompanyView from "./components/FilmCompanyView.vue"
import FilmProject from "./components/Projects/FilmProject.vue"
import Users from "./components/Admin/Users.vue"
import BussinesCompanies from "./components/BussinesCompanies.vue"
import BussinesCompaniesList from "./components/BussinesCompaniesList.vue"
import BussinesAreas from "@/components/BussinesAreas.vue";
import FilmView from "./views/FilmView.vue"
import OtherPracticView from "./views/OtherPracticView.vue"
import MoviestartDistributionView from "./views/MoviestartDistributionView.vue"
import ProjectRequests from "./views/ProjectRequests.vue"
import ToExpert from "./views/ToExpert/ToExpert.vue"
import ListExperts from "./views/ListExperts.vue"
import ExpertScores from "@/views/ToExpert/ExpertScores.vue";
import CompaniesList from "@/views/Companies/CompaniesList.vue";
import CompetitionReport from "@/views/Competition/CompetitionReport.vue";
import ProjectsBase from "@/views/ProjectsBase.vue";
import ToExpertProject from "@/views/ToExpert/ToExpertProject.vue";
import ProjectsToDelete from "@/views/Admin/ProjectsToDelete.vue";
import ProjectCustom from "@/components/Projects/ProjectCustom.vue";
import CompetitionCatalog from "@/views/Competition/CompetitionCatalog.vue";
import IndexComplete from "@/views/Project/IndexComplete.vue";
import Custom128Report from "@/views/Competition/reports/Custom128Report.vue";
import CompetitionQuiz from "@/views/Competition/CompetitionQuiz.vue";
import CompettitionExtraFields from "@/views/Competition/CompettitionExtraFields.vue";
import Products from "@/components/Products.vue";
import Orders from "@/components/Orders.vue";

export default {
	name: 'App',
	data() {
		return {
			show: false
		}
	},
	created() {
	},
	computed: {
		currentPage() {
			return window.currentPage
		}
	},
	components: {
		NewsList,
		CoordTable,
		CoordTable2: defineAsyncComponent(() =>
			import('@/components/CoordTable2.vue')
		),
		FprkProject,
		Main,
		Slider,
		CompleteProject,
		Registration,
		Profile,
		AreaQuiz,
		Startup,
		News,
		ForumReport,
		Comissions,
		ExpertProjects,
		ForumForm,
		Criterion,
		RussiaFutureComponent,
		EditExpert,
		CompetitionEdit,
		Users,
		AreasInfo,
		FilmCompany,
		FilmCompanyView,
		CompetitionLists,
		FilmProject,
		BussinesCompanies,
		BussinesCompaniesList,
		FilmView,
		OtherPracticView,
		MoviestartDistributionView,
		BussinesAreas,
		ProjectRequests,
		ToExpert,
		ListExperts,
		ExpertScores,
		CompaniesList,
		CompetitionReport,
		ProjectsBase,
		ToExpertProject,
		//ProcessIndex,
		ProjectsToDelete,
		ProjectCustom,
		CompetitionCatalog,
		IndexComplete,
		Custom128Report,
		CompetitionQuiz,
		CompettitionExtraFields,
		Products,
		Orders
	},
}
</script>

<template>
  <template v-if="currentPage === 'slider'">
    <Slider></Slider>
  </template>
  <template v-if="currentPage === 'complete'">
    <CompleteProject></CompleteProject>
  </template>
  <template v-if="currentPage === 'myprofile'">
    <Profile></Profile>
  </template>
  <template v-if="currentPage === 'areaquiz'">
    <AreaQuiz></AreaQuiz>
  </template>
  <template v-if="currentPage === 'coord_table'">
    <CoordTable></CoordTable>
  </template>
  <template
      v-if="currentPage === 'coord_table2' || currentPage === 'coord_table2_full' || currentPage === 'coord_table2_deleted'">
    <CoordTable2></CoordTable2>
  </template>
  <template v-if="currentPage === 'startup'">
    <Startup></Startup>
  </template>
  <template v-if="currentPage === 'registration'">
    <Registration></Registration>
  </template>
  <template v-if="currentPage === 'news_create'">
    <News></News>
  </template>
  <template v-if="currentPage === 'news_list'">
    <NewsList></NewsList>
  </template>
  <template v-if="currentPage === 'comission_members' || currentPage === 'comission_members_info'">
    <Comissions></Comissions>
  </template>
  <template v-if="currentPage === 'expert_projects'">
    <ExpertProjects></ExpertProjects>
  </template>
  <template v-if="currentPage === 'forum_form'">
    <ForumForm></ForumForm>
  </template>
  <template v-if="currentPage === 'forum_report'">
    <ForumReport></ForumReport>
  </template>
  <template v-if="currentPage === 'fprk_project'">
    <FprkProject />
  </template>
  <template v-if="currentPage === 'criterion_new'">
    <Criterion />
  </template>
  <template v-if="currentPage === 'russia_future'">
    <RussiaFutureComponent />
  </template>
  <template v-if="currentPage === 'edit_expert'">
    <EditExpert></EditExpert>
  </template>
  <template v-if="currentPage === 'competition_edit'">
    <CompetitionEdit></CompetitionEdit>
  </template>
  <template v-if="currentPage === 'admin_users'">
    <Users></Users>
  </template>
  <template v-if="currentPage === 'areas_info'">
    <AreasInfo></AreasInfo>
  </template>
  <template v-if="currentPage === 'competition_lists'">
    <CompetitionLists></CompetitionLists>
  </template>
  <template v-if="currentPage === 'film_company'">
    <FilmCompany></FilmCompany>
  </template>
  <template v-if="currentPage === 'film'">
    <FilmProject></FilmProject>
  </template>
  <template v-if="currentPage === 'film_company_view'">
    <FilmCompanyView></FilmCompanyView>
  </template>
  <template v-if="currentPage === 'bussiness_companies'">
    <BussinesCompanies></BussinesCompanies>
  </template>
  <template v-if="currentPage === 'bussiness_companies_list'">
    <BussinesCompaniesList></BussinesCompaniesList>
  </template>
	<!--    <template v-if="currentPage === 'film_company'">-->
	<!--        <BussinesCompaniesList></BussinesCompaniesList>-->
	<!--    </template>-->
  <template v-if="currentPage === 'company_film'">
    <FilmView></FilmView>
  </template>
  <template v-if="currentPage === 'other_practic'">
    <OtherPracticView></OtherPracticView>
  </template>
  <template v-if="currentPage === 'moviestart_distribution'">
    <MoviestartDistributionView></MoviestartDistributionView>
  </template>
  <template v-if="currentPage === 'bussiness_areas'">
    <BussinesAreas></BussinesAreas>
  </template>
  <template v-if="currentPage === 'project_requests'">
    <ProjectRequests></ProjectRequests>
  </template>
  <template v-if="currentPage === 'to_expert'">
    <ToExpert></ToExpert>
  </template>
  <template v-if="currentPage === 'list_experts'">
    <ListExperts></ListExperts>
  </template>
  <template v-if="currentPage === 'my_score'">
    <ExpertScores></ExpertScores>
  </template>
  <template v-if="currentPage === 'companies_list'">
    <CompaniesList></CompaniesList>
  </template>
  <template v-if="currentPage === 'competition_report'">
    <CompetitionReport></CompetitionReport>
  </template>
  <template v-if="currentPage === 'projects_base'">
    <ProjectsBase></ProjectsBase>
  </template>
  <template v-if="currentPage === 'to_expert_project'">
    <ToExpertProject></ToExpertProject>
  </template>
	<!--    <template v-if="currentPage === 'project_index'">-->
	<!--        <ProcessIndex></ProcessIndex>-->
	<!--    </template>-->
  <template v-if="currentPage === 'projects_to_delete'">
    <ProjectsToDelete></ProjectsToDelete>
  </template>
  <template v-if="currentPage === 'update_custom'">
    <ProjectCustom />
  </template>
  <template v-if="currentPage === 'competition_catalog'">
    <CompetitionCatalog />
  </template>
  <template v-if="currentPage === 'index_completes'">
    <IndexComplete />
  </template>
  <template v-if="currentPage === 'report_128'">
    <Custom128Report />
  </template>
	<template v-if="currentPage === 'competition_extra_fields'">
    <CompettitionExtraFields />
  </template>
	<template v-if="currentPage === 'competition_quiz'">
		<CompetitionQuiz />
	</template>
  <template v-if="currentPage === undefined">
    <Main/>
  </template>
	<template v-if="currentPage === 'products_admin'">
		<Products />
	</template>
	<template v-if="currentPage === 'orders_admin'">
		<Orders />
	</template>
</template>

<style lang="scss">
body {
  font-size: 16px;
  font-family: "Roboto", sans-serif;
}

.ant-radio-wrapper {
  font-size: 16px;
}
.ant-tooltip-inner {
	padding: 15px !important;
}
//.ant-pagination-prev {
//    margin-top: 0;
//}
::selection {
  background-color: #F7C100; /* Желтый цвет выделения */
  color: #fff;
}

.gray_line {
  background: #E3E9F3;
  padding: 20px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding-bottom: 0;
}

.gray_inner a {
  color: #1d232d;
}

.request_content {
  padding: 30px 20px;
  background: #fff;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.requestsCount {
  color: #1E242E;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  padding: 5px;
  border-radius: 4px;
  margin-left: 7px;
  background: linear-gradient(92deg, #F7C100 0.01%, #F69400 100%);
}

.has_not_scored {
  border-radius: 12px;
  padding: 5px 7px;
  background: linear-gradient(135deg, #f7c100 0.01%, #f69400 100%);
  font-weight: 500;
  font-size: 15px;
  line-height: 135%;
  color: #1d232d;
  display: inline-block;
}

.link_back svg {
  margin-right: 10px;
}

.link_back a {
  font-weight: 400;
  font-size: 14px;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  color: rgba(0, 0, 0, 0.5);
}

.countries_block__title {
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 5px;
}

.countries_block__sub {
  font-weight: 500;
  margin-bottom: 0;
}

.tabs_wrapper {
  display: flex;
  margin-bottom: 30px;

  .tab_item {
    cursor: pointer;
    font-weight: 400;
    font-size: 18px;
    line-height: 120%;
    color: rgba(29, 35, 45, 0.6);
    padding-bottom: 10px;

    &:not(:last-child) {
      margin-right: 40px;
    }

    &.is_active {
      color: #1d232d;
      border-bottom: 3px solid #f69400;
      box-shadow: inset 0 0 32px 0 rgba(255, 255, 255, 0.16);
    }
  }
}
.ant-radio-wrapper {
	line-height: normal;
}
.ant-radio-group .radio-option {
	margin-bottom: 0;
}

</style>
